import React from 'react'
import { Outlet } from 'react-router-dom'
import LandingFooter from './LandingFooter'
import LandingHeader from './LandingHeader'


const LandingLayout = () => {
  return (
    <div>
        <LandingHeader />
        <Outlet />
        <LandingFooter />

    </div>
  )
}

export default LandingLayout;
